import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoiceDetailModel } from '@app/core/models/invoices/invoice-detail.model';
import { InvoiceViewType } from '@app/core/models/invoices/invoice-view-type.model';
import { Subject, Observable } from 'rxjs';
import { InvoiceTraceabilityModel } from '@app/core/models/invoices/traceability/invoice-traceability.model';
import { InvoiceService } from '@app/core/services/invoice.service';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { InvoiceVoucherFormComponent } from './invoice-voucher-form/invoice-voucher-form.component';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { InvoiceVoucherDetail } from '@app/core/models/invoices/vouchers/invoice-voucher-detail.model';
import * as _ from 'lodash';

@Component({
  selector: 'app-invoice-voucher',
  templateUrl: './invoice-voucher.component.html',
  styleUrls: ['./invoice-voucher.component.scss']
})
export class InvoiceVoucherComponent implements OnInit, OnDestroy {

  invoiceViewType: string;
  invoiceDetailModel: InvoiceDetailModel;
  submitted = true;
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  InvoiceTraceability: InvoiceTraceabilityModel;
  canUpdateVoucher: boolean = false;

  @ViewChild(InvoiceVoucherFormComponent) invoiceVoucherFormComponent: InvoiceVoucherFormComponent;

  constructor(
    private invoiceService: InvoiceService,
    private authenticationInfoService: AuthenticationInfoService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.invoiceViewType = this.route.snapshot.paramMap.get('invoiceViewType');
    let isSearchDetail = this.invoiceViewType == InvoiceViewType.SEARCH;
    let isPendingForVoucherValidation = this.invoiceViewType == InvoiceViewType.VOUCHERVALIDATED;

    this.route.data.subscribe(data => {
      this.invoiceDetailModel = data.invoice;

      this.canUpdateVoucher = (isSearchDetail || isPendingForVoucherValidation)
        && this.invoiceDetailModel.IsVoucher
        && !this.invoiceDetailModel.IsVoucherValidated
        && (this.authenticationInfoService.authentificatedUser.GroupsMembership.AllGroups.includes(this.invoiceDetailModel.CurrentAssignmentGroupId)
          || this.authenticationInfoService.authentificatedUser.GroupsMembership.NonERPComptabilityGroups.includes(this.invoiceDetailModel.Workflow.NonErpGroupId));
    });

    this.invoiceService.getInvoiceTraceability(this.invoiceDetailModel.Id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((invoiceTraceability: InvoiceTraceabilityModel) => {
        this.InvoiceTraceability = invoiceTraceability;
      });
  }

  get IsFormValid(): boolean {
    return !_.isNil(this.invoiceVoucherFormComponent) && this.invoiceVoucherFormComponent.InvoiceDetailForm.valid;
  }

  onBackToDetail() {
    if (_.isNil(this.invoiceViewType)) {
      this.router.navigate(['/invoices', InvoiceViewType.SEARCH, 'detail', this.invoiceDetailModel.Id]);
      return;
    }

    this.router.navigate(['/invoices', this.invoiceViewType, 'detail', this.invoiceDetailModel.Id]);
  }

  onSubmitVoucher() {
    if (this.invoiceVoucherFormComponent.InvoiceDetailForm.valid) {
      this.onUpdate()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((isConfirmed: boolean) => {
          if (isConfirmed) {
            this.updateVoucher();
          }
        });
    }
  }

  onUpdate(): Observable<any> {
    const confimModal = new ModalHelper().getConfirmationConfig(`Êtes-vous sûr de vouloir modifier ce bon à payer ?`);
    const dialog = this.dialog.open(ModalComponent, confimModal);

    return dialog.afterClosed()
      .pipe(takeUntil(this.unsubscribe$));
  }

  updateVoucher() {
    const voucherDetail: InvoiceVoucherDetail = new InvoiceVoucherDetail();
    voucherDetail.Id = this.invoiceDetailModel.Id;
    voucherDetail.VoucherAnalyticalCode = this.invoiceVoucherFormComponent.InvoiceDetailForm.controls.VoucherAnalyticalCode.value;
    voucherDetail.VoucherAnalyticalSection = this.invoiceVoucherFormComponent.InvoiceDetailForm.controls.VoucherAnalyticalSection.value;
    voucherDetail.VoucherComment = this.invoiceVoucherFormComponent.InvoiceDetailForm.controls.VoucherComment.value;
    voucherDetail.VoucherDepartment = this.invoiceVoucherFormComponent.InvoiceDetailForm.controls.VoucherDepartment.value;

    this.invoiceService.updateVoucher(voucherDetail, this.invoiceDetailModel.Id).subscribe(r_ => this.onBackToDetail());
  }


  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
